import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FileText } from "lucide-react"; // PDF-like icon

const Brouchers = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");
    const handleMediaQueryChange = (e) => setIsMobile(e.matches);

    mediaQuery.addEventListener("change", handleMediaQueryChange);
    return () =>
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, []);

  // Example brochure data
  const brochures = [
    {
      title: "MediMind Overview",
      description:
        "Get an overview of MediMind’s AI-powered healthcare solutions.",
      link: "/brochures/medimindbroucher.pdf",
    },
    {
      title: "MedOps",
      description: "Discover how MedOps streamlines healthcare operations.",
      link: "/medimindbroucher.pdf",
    },
    {
      title: "PharmaConnect",
      description:
        "Learn how PharmaConnect is transforming pharmacy management.",
      link: "/brochures/pharmaconnect.pdf",
    },
  ];

  return (
    <div className="w-full px-4 pt-12 pb-20 bg-gradient-to-b from-[#d2e5e4] to-[#f3f6f6] flex justify-center items-center">
      <motion.div
        className="flex flex-col w-full max-w-7xl bg-white shadow-xl rounded-2xl overflow-hidden p-10"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        {/* Header */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d302c] mb-4">
            Explore Our <span className="text-yellow-600">Brochures</span>
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-lg">
            Download our brochures to explore how MediMind’s AI-powered products
            are transforming healthcare. Knowledge at your fingertips.
          </p>
        </div>

        {/* Brochure Cards */}
        <div
          className={`grid gap-10 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}
        >
          {brochures.map((item, index) => (
            <motion.div
              key={index}
              className="bg-[#fafafa] border border-gray-200 rounded-xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 flex flex-col justify-between"
              whileHover={{ y: -8 }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="p-4 bg-yellow-100 rounded-full shadow-md">
                  <FileText className="w-8 h-8 text-yellow-600" />
                </div>
                <h3 className="text-xl font-semibold text-[#3d302c]">
                  {item.title}
                </h3>
              </div>
              <p className="text-gray-600 mb-6">{item.description}</p>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block text-center py-3 px-5 bg-gradient-to-r from-[#3d302c] to-[#5a4844] text-white font-medium rounded-lg hover:opacity-90 transition duration-300"
              >
                Download PDF
              </a>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default Brouchers;
